module.exports = __webpack_public_path__ + "static/img/oilApplication7.9286070b.png";